import {axiosInstance} from '@/setup/axios/AxiosConfig';
import BaseRepository from '@/core/standard/BaseRepository';
import {GenericMethod} from '@/core/Types/IRepository';


class BarStockServices extends BaseRepository {
  public collection = 'bars_stocks';
  public version = 'v1';

  public async sendEmail(params: GenericMethod) {
    return await this.request({
      ...params, 
      url: 'stock_purchase_orders_email', 
      method: 'POST'
    });
  }

  public async downloadPDF(params: GenericMethod) {
    return await this.request({
      ...params, 
      url: 'stock_purchase_orders_pdf', 
      method: 'POST'
    });
  }

  public downloadPurchaseFile(params: GenericMethod) {
    return this.request({...params, url: 'download/stock_purchases'});
  }

  public downloadPurchaseOrderFile(params: GenericMethod) {
    return this.request({...params, url: 'download/stock_purchase_orders'});
  }

  public downloadStockProductsFile(params: GenericMethod) {
    return this.request({...params, url: 'download/stock_products'});
  }
}

export default new BarStockServices(axiosInstance);

